<template>
    <Column
        :xs-size="xsSize"
        :sm-size="smSize"
        :md-size="mdSize"
        :lg-size="lgSize"
        :xl-size="xlSize"
        :no-margin-top="noMarginTop"
    >
        <LabelTag :style="labelStyle" class="mb-0"> {{ $t(title) }} {{title2}}</LabelTag>

        <InputTag
            :model-form="modelForm"
            :model-name="modelName"
            :placeholder="placeholder"
            :inputFunction="inputFunction"
            :type="type"
            :is-disabled="isDisabled"
            :min="min"
            :is-bg-danger="isBgDanger"
        />

        <InvalidForm
            v-if="checkToModel !== undefined"
            :state="this[checkToModel](modelName, limit)"
            :text="errors[modelName]"/>
    </Column>
</template>

<script>
import Column from "./html/Column";
import InputTag from "./html/InputTag";
import LabelTag from "./html/LabelTag";
import sizeClassesMixin from "./html/mixin/sizeClassesMixin";
import InvalidForm from "./html/InvalidForm";
import validatorMixin from "../mixin/validatorMixin";

export default {
    name: "InputBox",
    mixins: [validatorMixin, sizeClassesMixin],
    components: {InvalidForm, LabelTag, InputTag, Column},
    props: {
        modelForm: {
            type: Object,
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },

        // optional
        errors: {
            type: Object,
            default: null,
        },
        checkToModel: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            default: "",
        },
        title2: {
            type: String,
            default: "",
            color: null
        },
        placeholder: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "text",
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        labelStyle: {
            type: String,
            default: '',
        },
        inputFunction: {
            type: Function,
            default: function () {
            },
        },
        limit: {
            type: Number,
            default: 0
        },

        // column
        noMarginTop: {
            type: Boolean,
            default: false
        },
        min: {
            type: String,
            default: null
        },
        isBgDanger: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>